export const DEFAULT_EXCLUDED_TAGS = ['HEADER', 'NAV', 'FOOTER', 'SCRIPT', 'STYLE'];
export const DEFAULT_EXCLUDED_IDS: string[] = [];
export const CV_SHARE_IGNORE_ATTRIBUTE = 'data-cv-share-ignore';
